import {
  simpleFadeAnimation,
  InOutAnimation,
} from './../../../../../shared/animations/animations';
import {
  RefundActionEnum,
  RefundItem,
  RefundStatusEnum,
} from './../../../../../models/owner-dashboard';
import { SharedRefundService } from './../../shared-refund.service';
import {
  Component,
  Input,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';

import { Router } from '@angular/router';
import {
  LearmoModalRef,
  LearmoModalService,
} from 'src/app/shared/services/learmo-modal.service';

@Component({
  selector: 'app-refund-item-popup',
  templateUrl: './refund-item-popup.component.html',
  styleUrls: ['./refund-item-popup.component.css'],
  animations: [simpleFadeAnimation, InOutAnimation],
})
export class RefundItemPopupComponent implements OnInit {
  @Input() refundItem: RefundItem;
  refundStatusEnum = RefundStatusEnum;
  refundActionEnum = RefundActionEnum;

  @ViewChild('modalContent') modalContent: TemplateRef<any>;
  @Input() modalRef: LearmoModalRef;
  processing: boolean = false;

  constructor(
    public sharedRefundService: SharedRefundService,
    private modalService: LearmoModalService,
    private route: Router
  ) {}

  async ngOnInit() {}

  closeModal() {
    if (this.modalRef) {
      this.modalRef.dismiss();
    }
  }
  // Affiliate Links List

  // Modal Open
  async open(content?) {
    this.onOpenModal();
    this.modalRef = this.modalService.open(this.modalContent, {
      title: 'Refund Request Summary',
      icon: 'monitor', // Mapping ler-devices to monitor
      size: 'fullscreen',
      premium: true,
      // footer: this.modalFooter // No footer
    });
  }

  async onOpenModal() {
    // this.resetForm();
    // this.productObject.type_id = 1;
    // this.resetProcess();
  }

  onStart(mark: 'Refused' | 'Refunded' = 'Refunded') {
    this.processing = true;
  }

  onSuccess(mark: 'Refused' | 'Refunded' = 'Refunded') {
    setTimeout(() => {
      this.closeModal();
    }, 1000);

    this.processing = false;
  }

  onError(error: any) {
    this.processing = false;
  }
}
